<template>
  <footer class="footer">
    <div class="footer__container">
      <div class="left">
        <div v-for="contact in contacts" :key="contact.name" class="contact">
          <component :is="contact.icon" class="contact__icon"/>
          <a :href="contact.link" class="contact__link">{{ contact.name }}</a>
        </div>

        <div class="contact">
          <clock class="contact__icon contact__icon--white"/>
          <div class="contact__text">
            {{ $t('footer.working-time') }}
          </div>
        </div>
      </div>

      <footer-menu :menu="menu"/>
    </div>

    <div class="copyright">
      <div class="sf-cg sf-pv">
        <p class="copyright__text">{{ `© ${currentYear} ${$t('footer.info')}` }}</p>
      </div>
    </div>
  </footer>
</template>

<script>
import ClockItem from '~/static/img/icons/clock-time.svg';
import MailIcon from '~/static/img/icons/email.svg';
import PhoneIcon from '~/static/img/icons/phone-in-talk.svg';
import InstagramIcon from '~/static/img/icons/instagram.svg';
import TiktokIcon from '~/static/img/icons/tiktok.svg';
import YoutubeIcon from '~/static/img/icons/youtube.svg';
import FooterMenu from '~/components/footer/footer-menu.vue';
import { WEB_ROUTES } from '~/app/shared/utils/web-config';

export default {
  name: 'Footer',
  components: {
    FooterMenu,
    Clock: ClockItem,
    Mail: MailIcon,
    Phone: PhoneIcon,
    Instagram: InstagramIcon,
  },
  data: () => ({
    currentYear: new Date().getFullYear(),
  }),
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    contacts() {
      return [
        { icon: PhoneIcon, link: `tel:${this.$t('footer.phone')}`, name: this.$t('footer.phone') },
        {
          icon: MailIcon,
          link: `mailto:${this.$t('footer.email')}`,
          name: this.$t('footer.email'),
        },
        {
          icon: InstagramIcon,
          link: this.$t('footer.instagram-link'),
          name: this.$t('footer.instagram-link-title'),
        },
        {
          icon: TiktokIcon,
          link: this.$t('footer.tiktok-link'),
          name: this.$t('footer.tiktok-link-title'),
        },
        {
          icon: YoutubeIcon,
          link: this.$t('footer.youtube-link'),
          name: this.$t('footer.youtube-link-title'),
        },
      ];
    },
    menu() {
      return [
        {
          title: this.$t('footer.company-title'),
          links: [
            { label: this.$t('footer.about-us'), url: WEB_ROUTES.ABOUT },
            { label: this.$t('footer.contacts'), url: WEB_ROUTES.CONTACT },
          ],
        },
        {
          title: this.$t('footer.clients-title'),
          links: [
            { label: this.$t('footer.how-to-get'), url: WEB_ROUTES.HOW_TO_GET },
            { label: this.$t('footer.how-to-pay'), url: WEB_ROUTES.HOW_TO_PAY },
            { label: this.$t('footer.documents'), url: WEB_ROUTES.DOCUMENTS },
            { label: this.$t('footer.faq-block'), url: WEB_ROUTES.FAQ },
          ],
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  border-top: 1px solid map_get($colors, border);

  &__container {
    padding: 40px 20px;

    @include mobile {
      padding-bottom: 0;
    }

    @include tablet {
      @include contentGrid;
      display: flex;
      justify-content: space-between;
    }
  }

  .contact {
    display: flex;
    align-items: center;

    &:not(:last-child) {
      margin-bottom: 32px;
    }

    &__icon {
      fill: map-get($colors, secondary);
      @include square(24px);
      margin-right: 24px;
    }

    &__text {
      a {
        color: map-get($colors, text);
      }
    }

    &.highlight {
      font-size: 24px;
      font-weight: 600;
      fill: map-get($colors, secondary);

      a {
        color: map-get($colors, text);
      }
    }
  }

  .left {
    width: 50%;
    @include tablet-only {
      width: 30%;
      border-bottom: none;
    }

    @include mobile {
      @include contentGrid;
      padding-bottom: 40px;
    }
  }

  .copyright {
    @include tablet {
      border-top: 1px solid map_get($colors, border);
    }
    &__text {
      font-size: 14px;
    }
  }

  & /deep/ .toggle {
    @include tablet {
      height: auto !important;
    }
  }
}
</style>
